// src/utils/generateDocketPDF.js
import bwipjs from 'bwip-js';
import SiteLogo from '../assets/images/SparkLogistics.jpg';

// Helper: Check if string is a 24-char hex MongoDB ObjectId
const isMongoId = (str) => typeof str === 'string' && /^[0-9a-fA-F]{24}$/.test(str.trim());

// Helper: Clean string and filter out MongoDB ObjectIds
const cleanStr = (val, fallback = '') => {
  if (!val) return fallback;
  if (typeof val === 'object') {
    if (val.branchname && !isMongoId(val.branchname)) return val.branchname;
    if (val.companyName && !isMongoId(val.companyName)) return val.companyName;
    if (val.name && !isMongoId(val.name)) return val.name;
    if (val.areaname && !isMongoId(val.areaname)) return val.areaname;
    if (val.hub && !isMongoId(val.hub)) return val.hub;
    if (val.pincode && !isMongoId(val.pincode)) return String(val.pincode);
    return fallback;
  }
  const s = String(val).trim();
  if (isMongoId(s)) return fallback;
  return s;
};

// ------------------ HTML TEMPLATE FUNCTION ------------------
const htmlString = (data, logoSrc, barcodeImg) => {
  const measurements = data.Measurements || [];
  const measurementLines = measurements
    .map(m => (typeof m === 'string' ? m : `${m.nos || 1} Pcs @ ${m.length || 0}x${m.breadth || 0}x${m.height || 0} cm`))
    .concat(new Array(4 - measurements.length).fill('---------------------------------'))
    .slice(0, 4)
    .map(line => `<span>${line}</span><br>`)
    .join('');

  const barcodeImgTag = `<img src="${barcodeImg}" style="max-width:95%; max-height:90%; object-fit:contain;" />`;

  const copy = (id) => `
    <div class="consignment-note">
      <div class="column flex-column">
        <div class="header-section border-bottom">
          <div class="logo-box">
            <img src="${logoSrc}" alt="logo">
          </div>
          <div class="company-info">
            <h2 class="brand-name">SPARK LOGISTICS</h2>
            <p class="gst-text"><strong>GST:</strong> 33AFXFS0632L1ZJ</p>
            <p class="email-text">info@sparklogistics.in | Ph: +91 98401 41628</p>
          </div>
        </div>

        <div class="border-bottom" style="height:75px; padding:5px;">
          <h5>Consignee:</h5>
          <p style="font-size:10px; line-height:1.2;">
            <strong>${data.Consignee || 'N/A'}</strong><br>
            ${data.ConsigneeAddress || 'N/A'}${data.Consigneepin ? `, ${data.Consigneepin}` : ''}
          </p>
        </div>
        
        <div class="flex-column border-bottom" style="flex-grow:1; padding:5px;">
          <h5>Terms and Condition</h5>
          <p style="font-size:8.2px; line-height:1.2; text-align:justify; color: #444;">
            I/We declare that this consignment does not contain personal mail, cash, jewellery, contraband, or prohibited items. Subject to booking station jurisdiction.
          </p>
        </div>
        
        <div style="height:40px; padding:5px; display:flex; align-items:flex-end;">
          <h5 style="font-size:9px; color:#666; border-top: 1px dashed #ccc; width: 100%;">CONSIGNOR SIGN</h5>
        </div>
      </div>

      <div class="column flex-column">
        <div class="flex-row border-bottom" style="height:25px; background: #f0f0f0;">
          <div style="width:50%; text-align:center; border-right:1px solid black; font-size:9px; font-weight:bold; line-height:25px;">ORIGIN</div>
          <div style="width:50%; text-align:center; font-size:9px; font-weight:bold; line-height:25px;">DESTINATION</div>
        </div>
        <div class="flex-row border-bottom" style="height:25px;">
          <div style="width:50%; text-align:center; border-right:1px solid black; font-size:11px; line-height:25px;">${data.Origin || 'N/A'}</div>
          <div style="width:50%; text-align:center; font-size:11px; line-height:25px;">${data.Destination || 'N/A'}</div>
        </div>
        
        <div class="flex-row border-bottom" style="height:40px;">
          <div style="width:50%; text-align:center; border-right:1px solid black; font-size:10px; line-height:25px;">${data.Date || 'N/A'}</div>
          <div style="width:50%; text-align:center; font-size:10px; line-height:25px;">MODE: ${data.Mode || 'N/A'}</div>
        </div>

        <div class="border-bottom" style="height:75px; padding:5px;">
          <h5>Consignor:</h5>
          <p style="font-size:10px; line-height:1.2;">
            <strong>${data.Consignor || 'N/A'}</strong><br>
            ${data.Consignoradd || 'N/A'}${data.Consignorpin ? `, ${data.Consignorpin}` : ''}
          </p>
        </div>

        <div style="flex-grow:1; padding:5px; display:flex; align-items:flex-end;">
          <h4 style="font-size:9px; color:#555;">Consignee Sign & Seal:</h4>
        </div>
      </div>

      <div class="column flex-column">
        <div class="border-bottom center" style="height:90px; padding-top:5px;">
          ${barcodeImgTag}
        </div>
        <div class="border-bottom center" style="height:35px;">
          <p style="font-size:16px; font-weight:bold; letter-spacing:2px;">${data.Docket || 'N/A'}</p>
        </div>

        <div id="interiorCheck">
          <div class="flex-row" style="justify-content:space-between; border-bottom:1px solid #000; padding-bottom:2px; margin-bottom:5px;">
            <div style="font-weight:bold; font-size:10px;">Inv: ${data.InvoiceNo || 'N/A'}</div>
            <div style="font-weight:bold; font-size:10px;">${data.Dox || data.NonDox}</div>
          </div>
          <div class="row-item">No Of Pckgs: <strong>${data.NoOfBox || 0}</strong></div>
          <div class="row-item">Decl Value: ${data.DeclaredValue || '0'}</div>

          <div style="font-weight:bold; font-size:9px; margin-top:5px; background:#eee; padding-left:2px;">Dimensions (cms)</div>
          <div class="lines">${measurementLines}</div>

          <div class="row-item" style="margin-top:5px;">Act Wt: <strong>${data.Weight || 0} kg</strong></div>
          <div class="row-item">Vol Wt: <strong>${data.VolWeight || 0} kg</strong></div>

          <div style="border-top:1px solid #ccc; margin-top:5px; padding-top:2px;">
            <div class="row-item">Freight: ${data.Freight || 0}</div>
            <div class="row-item">Fuel/ODA: ${(data.FuelSurcharge || 0) + (data.ODAcharges || 0)}</div>
            <div class="row-item">GST: ${data.Gst || 0}</div>
            <div class="row-item" style="font-size:12px; font-weight:bold; border-top:1px solid black; margin-top:2px; padding-top:2px;">
              TOTAL: ₹${data.GrandTotal || 0}
            </div>
            <div class="row-item" style="font-size:9px; color:#666;">Mode: ${data.PaymentMode}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="footerData">
      PL NO.31, Chinnaswamy Street, VGN Mahalakshmi Nagar, Ayanambakkam, Chennai, Tiruvallur, Tamil Nadu - 600095 | Mobile: +91 98401 41628 | Email: info@sparklogistics.in
    </div>
  `;

  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <style>
    * { box-sizing: border-box; }
    body { margin:0; padding:15px; font-family: Arial, sans-serif; color: #000; }
    p, h5, h4 { margin:0; padding:0; }
    h5 { font-size:11px; font-weight:bold; text-decoration: underline; margin-bottom:3px; }
    
    .consignment-note { 
      width: 800px; 
      height: 380px; 
      margin: 0 auto 10px auto; 
      border: 2px solid black; 
      display: flex; 
      page-break-inside: avoid; 
    }

    .column { width: 33.33%; border-right: 1px solid black; display: flex; flex-direction: column; }
    .column:last-child { border-right: none; }
    
    /* Header Styles */
    .header-section {
      height: 90px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 5px;
    }
    .logo-box {
      width: 40%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .logo-box img {
      max-width: 100%;
      max-height: 80px;
      object-fit: contain;
      mix-blend-mode: multiply;
    }
    .company-info {
      width: 60%;
      padding-left: 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .brand-name {
      font-size: 16px;
      font-weight: 900;
      margin: 0;
      color: #000;
      letter-spacing: 0.5px;
    }
    .gst-text { font-size: 9px; margin-top: 2px; }
    .email-text { font-size: 9px; color: #444; }

    .border-bottom { border-bottom: 1px solid black; }
    .center { display: flex; justify-content: center; align-items: center; }
    .flex-column { display: flex; flex-direction: column; }
    .flex-row { display: flex; }

    #interiorCheck { padding: 8px; flex-grow: 1; }
    .row-item { font-size: 10px; margin-bottom: 2px; display: flex; justify-content: space-between; }
    .lines span { font-size: 8px; color: #555; font-family: monospace; }
    
    .footerData { 
      width: 800px; 
      margin: 0 auto 30px auto; 
      font-size: 8.5px; 
      text-align: center; 
      border: 1px solid black; 
      border-top: none; 
      padding: 3px;
      background: #f9f9f9;
      font-weight: bold;
    }

    @media print {
      body { padding: 0; }
      .consignment-note, .footerData { width: 100%; }
    }
  </style>
</head>
<body>
  ${copy(1)}${copy(2)}${copy(3)}
</body>
</html>
  `;
};

// ------------------ MAIN FUNCTION ------------------
export const generateDocketPDF = async (docket, volumeFactor = 4500, customerPrices = []) => {
  const logoToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (e) {
      console.error("Logo load failed", e);
      return "";
    }
  };

  const logoBase64 = await logoToBase64(SiteLogo);

  // Consignee mapping
  const consigneeObj = docket.consigneeid || {};
  const consigneeName = cleanStr(consigneeObj.companyName) || cleanStr(consigneeObj.name) || cleanStr(docket.consigneename) || cleanStr(docket.consignee) || 'N/A';
  const rawConsigneeAddr = cleanStr(consigneeObj.deliveryAddress) || cleanStr(consigneeObj.address) || cleanStr(consigneeObj.address1) || cleanStr(consigneeObj.city) || cleanStr(docket.consigneeaddress);
  const consigneePin = cleanStr(consigneeObj.pincode?.pincode) || cleanStr(consigneeObj.pincode) || cleanStr(docket.topincode) || cleanStr(docket.pincode) || '';
  const consigneeAddress = rawConsigneeAddr || (consigneeName !== 'N/A' ? consigneeName : '');

  // Consignor mapping - Outgoing / Booking response mapping
  const consignorObj = docket.consignorid || docket.clientid || docket.pickrequestid?.clientid || {};
  const consignorName = cleanStr(docket.consignor) || cleanStr(docket.consignors) || cleanStr(consignorObj.companyName) || cleanStr(consignorObj.name) || cleanStr(docket.consignorname) || cleanStr(docket.clientname) || 'Walk-in Customer';
  const rawConsignorAddr = cleanStr(docket.consignoraddress) || cleanStr(consignorObj.deliveryAddress) || cleanStr(consignorObj.address) || cleanStr(consignorObj.address1) || cleanStr(docket.clientid?.address);
  const consignorPin = cleanStr(consignorObj.pincode?.pincode) || cleanStr(consignorObj.pincode) || cleanStr(docket.consignorpin) || cleanStr(docket.frompincode) || '';
  const consignorAddress = rawConsignorAddr || (consignorName !== 'Walk-in Customer' ? consignorName : '');

  // Rate Master Location Lookup
  const custId = docket.consigneeid?._id || docket.consigneeid || docket.clientid?._id || docket.clientid || docket.consignorid?._id || docket.consignorid;
  let rateOrigin = '';
  let rateDest = '';

  if (custId && Array.isArray(customerPrices) && customerPrices.length > 0) {
    const match = customerPrices.find(p => String(p.customerId?._id || p.customerId) === String(custId));
    if (match) {
      if (match.fromLocationId) {
        if (Array.isArray(match.fromLocationId) && match.fromLocationId.length > 0) {
          const names = match.fromLocationId.map(l => cleanStr(l)).filter(Boolean);
          if (names.length > 0) rateOrigin = names.join(', ');
        } else {
          const name = cleanStr(match.fromLocationId);
          if (name) rateOrigin = name;
        }
      }
      if (match.toLocationId) {
        if (Array.isArray(match.toLocationId) && match.toLocationId.length > 0) {
          const names = match.toLocationId.map(l => cleanStr(l)).filter(Boolean);
          if (names.length > 0) rateDest = names.join(', ');
        } else {
          const name = cleanStr(match.toLocationId);
          if (name) rateDest = name;
        }
      }
    }
  }

  // Origin & Destination mapping
  // Origin: Customer Branch / Rate Master / Location
  const originName = rateOrigin || cleanStr(docket.customerbranch?.branchname) || cleanStr(docket.customerbranch?.name) || cleanStr(docket.customerbranch) || cleanStr(docket.branchid?.branchname) || cleanStr(docket.branchid?.name) || cleanStr(docket.branchid) || cleanStr(docket.originlocation?.areaname) || cleanStr(docket.originlocation?.hub) || cleanStr(docket.originlocation?.name) || cleanStr(docket.fromlocation?.areaname) || cleanStr(docket.origin) || 'N/A';

  // Destination: Booking Destination / Rate Master Location response
  const destinationName = rateDest || cleanStr(docket.destlocation?.areaname) || cleanStr(docket.destlocation?.hub) || cleanStr(docket.destlocation?.name) || cleanStr(docket.tolocation?.areaname) || cleanStr(docket.locationid?.areaname) || cleanStr(docket.destination) || 'N/A';

  // Mode mapping
  const modeName = docket.mode === 1 ? 'Surface' : docket.mode === 2 ? 'Air' : docket.mode === 3 ? 'Train' : (cleanStr(docket.mode) || 'Surface');

  // Measurements & Volumetric Calculation (LxBxH / volumeFactor)
  const volDivisor = Number(volumeFactor) > 0 ? Number(volumeFactor) : (Number(consigneeObj.volume) > 0 ? Number(consigneeObj.volume) : 4500);
  const measurements = docket.docketmeasurement || [];

  let calcVolWeight = 0;
  let totalPkgs = 0;

  const mappedMeasurements = measurements.map(m => {
    const qty = Number(m.nos) || 1;
    const l = Number(m.length) || 0;
    const b = Number(m.breadth) || 0;
    const h = Number(m.height) || 0;
    
    totalPkgs += qty;
    const cubic = l * b * h;
    if (cubic > 0) {
      calcVolWeight += (cubic / volDivisor) * qty;
    }
    return {
      nos: qty,
      length: l,
      breadth: b,
      height: h,
    };
  });

  const finalNoOfBox = totalPkgs > 0 ? totalPkgs : (Number(docket.noofpiece) || Number(docket.noofbox) || 0);

  const finalVolWeight = calcVolWeight > 0 
    ? calcVolWeight.toFixed(2) 
    : (Number(docket.totvolweight) || Number(docket.volweight) || 0).toFixed(2);

  const data = {
    Docket: docket.docket || 'N/A',
    Date: docket.bookingdate ? new Date(docket.bookingdate).toLocaleDateString('en-GB') : 'N/A',

    // Locations
    Origin: originName,
    Destination: destinationName,

    // Mode
    Mode: modeName,

    // Consignor
    Consignor: consignorName,
    Consignoradd: consignorAddress,
    Consignorpin: consignorPin,

    // Consignee
    Consignee: consigneeName,
    ConsigneeAddress: consigneeAddress,
    Consigneepin: consigneePin,

    // Items & Weight
    InvoiceNo: docket.referenceno || 'N/A',
    Dox: docket.isdoxornon === 1 ? 'DOX' : '',
    NonDox: docket.isdoxornon === 0 ? 'NON-DOX' : '',
    NoOfBox: finalNoOfBox,
    DeclaredValue: docket.cvalue || 0,
    VolWeight: finalVolWeight,
    Weight: docket.actweight || 0,

    // Charges
    PaymentMode: docket.paymode || 'Prepaid',
    Freight: docket.frieghtcharge || 0,
    FuelSurcharge: docket.fuelcharge || 0,
    ODAcharges: docket.odacharge || 0,
    Gst: (docket.cgst || 0) + (docket.sgst || 0),
    GrandTotal: docket.grandtotal || 0,

    // Measurements array
    Measurements: mappedMeasurements,
  };

  const canvas = document.createElement('canvas');
  let barcodeDataUrl = '';
  try {
    await bwipjs.toCanvas(canvas, {
      bcid: 'code128',
      text: data.Docket,
      scale: 3,
      height: 12,
      includetext: false,
    });
    barcodeDataUrl = canvas.toDataURL('image/png');
  } catch (e) {
    console.error('Barcode failed', e);
  }

  const html = htmlString(data, logoBase64, barcodeDataUrl);
  const win = window.open('', '_blank');
  win.document.write(html);
  win.document.close();
};